/**
 * Configuração compartilhada do worker do pdfjs-dist.
 *
 * Importar este módulo em qualquer componente que use react-pdf
 * para garantir que o worker seja inicializado apenas uma vez.
 */
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();
